"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * @param {V2.RefundDataGrouping} _
 * @returns {V2.RefundPolicyGroupInfo}
 */
function stationRefundTerms(_) {
  // eslint-disable-line no-unused-vars
  return {
    icon: "dollar-sign",
    method: "!refund-and-exchange.content.refund.station.method",
    method_simplified: "!refund-and-exchange.content.refund.station.method.simplified"
  };
}

exports.default = stationRefundTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92Mi9yZWZ1bmRzL3N0YXRpb24tcmVmdW5kcy5qcyJdLCJuYW1lcyI6WyJzdGF0aW9uUmVmdW5kVGVybXMiLCJfIiwiaWNvbiIsIm1ldGhvZCIsIm1ldGhvZF9zaW1wbGlmaWVkIl0sIm1hcHBpbmdzIjoiOzs7OztBQUFBOztBQUVBOzs7O0FBSUEsU0FBU0Esa0JBQVQsQ0FBNEJDLENBQTVCLEVBQStCO0FBQzdCO0FBQ0EsU0FBTztBQUNMQyxVQUFNLGFBREQ7QUFFTEMsWUFBUSxvREFGSDtBQUdMQyx1QkFBbUI7QUFIZCxHQUFQO0FBS0Q7O2tCQUVjSixrQiIsImZpbGUiOiJzdGF0aW9uLXJlZnVuZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAdHMtY2hlY2tcblxuLyoqXG4gKiBAcGFyYW0ge1YyLlJlZnVuZERhdGFHcm91cGluZ30gX1xuICogQHJldHVybnMge1YyLlJlZnVuZFBvbGljeUdyb3VwSW5mb31cbiAqL1xuZnVuY3Rpb24gc3RhdGlvblJlZnVuZFRlcm1zKF8pIHtcbiAgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby11bnVzZWQtdmFyc1xuICByZXR1cm4ge1xuICAgIGljb246IFwiZG9sbGFyLXNpZ25cIixcbiAgICBtZXRob2Q6IFwiIXJlZnVuZC1hbmQtZXhjaGFuZ2UuY29udGVudC5yZWZ1bmQuc3RhdGlvbi5tZXRob2RcIixcbiAgICBtZXRob2Rfc2ltcGxpZmllZDogXCIhcmVmdW5kLWFuZC1leGNoYW5nZS5jb250ZW50LnJlZnVuZC5zdGF0aW9uLm1ldGhvZC5zaW1wbGlmaWVkXCJcbiAgfTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgc3RhdGlvblJlZnVuZFRlcm1zO1xuIl19